module.exports = __webpack_public_path__ + "img/photoService.661c73f3.svg";